import React from 'react';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { AiBorderBox } from '@shared/components/AiBorderBox';
import { JoyAiV2 } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';

// @todo [TRAV-2250] Replace with actual status from API - Completed / In Progress / Empty / Error
const VacationRentalsCompletedStatus = React.memo(() => {
  const { tq } = useTranslation('accommodationsAdmin');
  return (
    <AiBorderBox
      padding={6}
      background="white"
      borderRadius={12}
    >
      <Flex
        gap={3}
        alignItems="center"
      >
        <JoyAiV2 size={48} />
        <TextV2
          typographyVariant={'body1'}
          textAlign="left"
          fontSize={pxToRem(14)}
        >
          {tq`We found a few curated stay zones suggestions near your venue. Add, remove and tweak them the way you want.`}
        </TextV2>
      </Flex>
    </AiBorderBox>
  );
});

export const VacationRentalsStatus: React.FC = () => {
  return (
    <Box
      marginTop={6}
      marginX={6}
    >
      <VacationRentalsCompletedStatus />
    </Box>
  );
};
